//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteBlockDisplayItem } from './WebsiteBlockDisplayItem';

export class WebsitePageDisplayItem extends ItemBase {
    ID: string | null = null;
    ParentPageID: string | null = null;
    WebsiteID: string | null = null;
    Description: string | null = null;
    InMenu: boolean = false;
    Keywords: string[] = [];
    OrderIndex: number = 0;
    RobotsIndex: boolean = false;
    SEOTitle: string | null = null;
    Title: string | null = null;
    Slug: string | null = null;
    IsHomepage: boolean = false;
    Url: string | null = null;
    LastModifiedUTC: string = "1970-01-01T00:00:00";
    LastModified: string = "1970-01-01T00:00:00";
    ChildPages: WebsitePageDisplayItem[] = [];
    WebsiteBlocks: WebsiteBlockDisplayItem[] = [];

    constructor(initializer?: Partial<WebsitePageDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsitePageDisplayItem";
}
